export const useRouter = () => {
  return {
    goToLoginPage: () => window.location.assign('/'),
  };
};
